import React, {Component, Fragment} from 'react';
import DispatchProps from "../../../utils/DispatchProps";
import School from "../../../models/School";
import SchoolList from "../../SchoolList";
import {friendlySchoolName} from "../../../utils/Utils";
import ApiService from "../../ApiService";
import H from "history";
import SdsSubject from "../../../models/SdsSubject";
import SdsYear from "../../../models/SdsYear";
import Table from "../../Table";
import SyncSubjectsAndYearsPrompt from "../../SyncSubjectsAndYearsPrompt";
import Subject from '../../../models/Subject';
import {connect} from "react-redux";
import {IRootState} from "../../../store";
import SchoolPageTitle from '../../SchoolPageTitle';
import AdminSchoolMenu from '../../AdminSchoolMenu';
import AcademicYearPicker from '../../AcademicYearPicker';

interface AnalyseSchoolDataPageProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
    history: H.History;
    academicYear: number;
}

interface AnalyseSchoolDataPageState {
    school?: School;
    sdsSubjects?: SdsSubject[];
    sdsYears?: SdsYear[];
    disableGenerateButton: boolean;
    subjectsProcessed?: Subject[];
}

class AnalyseSchoolDataPage extends Component<AnalyseSchoolDataPageProps & DispatchProps ,AnalyseSchoolDataPageState> {
    static displayName = AnalyseSchoolDataPage.name;

    private static readonly sdsSubjectColumns = [
        {title: "Name",propertyPath: "subjectName", flex: 1},
        {title: "Code",propertyPath: "subjectCode", flex: 1},
    ];

    private static readonly sdsYearColumns = [
        {title: "Name",propertyPath: "yearName", flex: 1},
    ];

    private static readonly subjectProcessedInWorkloadsColumns = [
        { title: "Name", propertyPath: "subjectName", enableSort: true, flex: 1 },
        { title: "Code", propertyPath: "subjectCode", enableSort: true, flex: 1 },
        { title: "Class Count", propertyPath: "classCount", enableSort: true, flex: 1}
    ];

    constructor(props: AnalyseSchoolDataPageProps & DispatchProps) {
        super(props);

        this.state = {
            disableGenerateButton: false
        }
    }

    async componentDidMount()
    {
        if (this.props.tenantId && this.props.schoolCode) {
            await this.fetchData();
        }
    }

    async componentDidUpdate(prevProps: Readonly<AnalyseSchoolDataPageProps & DispatchProps>, prevState: Readonly<AnalyseSchoolDataPageState>, snapshot?: any): Promise<void> {

        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode || this.props.academicYear !== prevProps.academicYear) {
            await this.fetchData();
        }
    }
    
    private async fetchData()
    {
        if(this.props.tenantId && this.props.schoolCode)
        {
            const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode);
            const sdsSubjects = await this.props.apiService.getSdsSubjectsForSchool(this.props.tenantId,this.props.schoolCode);
            const sdsYears = await this.props.apiService.getSdsYearsForSchool(this.props.tenantId, this.props.schoolCode);
            const subjectsProcessed = await this.props.apiService.getSubjectsForSchool(this.props.tenantId, this.props.schoolCode, this.props.academicYear);
            
            this.setState({
                school,
                sdsSubjects,
                sdsYears,
                subjectsProcessed
            });
        }
    }
    
    render () {
        const schoolName = this.state.school ? friendlySchoolName(this.state.school) : "";

        
        return(
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Data" />

                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />

                {this.state.school ? <SyncSubjectsAndYearsPrompt school={this.state.school} message={"SyncSubjectsAndYears must have completed for SDS data to appear."}/> : null }

                <SchoolList title={schoolName} enableRowLinks={false} schools={this.state.school ? [this.state.school] :[]}/>

                <Table
                    className={"flex-item--flex-1"}
                    title={"SDS Subjects"}
                    items={this.state.sdsSubjects ? this.state.sdsSubjects : []}
                    columns={AnalyseSchoolDataPage.sdsSubjectColumns}
                    enableSort={true} >
                </Table>


                <div style={{ display: "flex", alignItems: "baseline" }}>
                    <AcademicYearPicker history={this.props.history} />
                    <span>Subjects are stored for each academic year</span>
                </div>
                <Table
                    className={"flex-item--flex-1"}
                    title={"Subjects In Assignment Analytics"}
                    items={this.state.subjectsProcessed ? this.state.subjectsProcessed : []}
                    columns={AnalyseSchoolDataPage.subjectProcessedInWorkloadsColumns}
                    enableSort={true} >
                </Table>

                <Table
                    className={"flex-item--flex-1"}
                    title={"SDS Years"}
                    items={this.state.sdsYears ? this.state.sdsYears : []}
                    columns={AnalyseSchoolDataPage.sdsYearColumns}
                    enableSort={true} >
                </Table>
                
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {history: H.History,match: any}): AnalyseSchoolDataPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;
        const academicYear = AcademicYearPicker.fromQueryStringOrDefault(ownProps.history.location.search);

        return {
            tenantId: tenantId,
            schoolCode: schoolCode,
            history: ownProps.history,
            academicYear: academicYear,
            apiService: state.auth.apiService
        };
    }
)(AnalyseSchoolDataPage)